import { render, staticRenderFns } from "./zhusu.vue?vue&type=template&id=2016a9d7&scoped=true&"
import script from "./zhusu.vue?vue&type=script&lang=js&"
export * from "./zhusu.vue?vue&type=script&lang=js&"
import style0 from "./zhusu.vue?vue&type=style&index=0&id=2016a9d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2016a9d7",
  null
  
)

export default component.exports